
/**
 * @class StoreService
 */
function StoreBackendProvider() {
    let bdcUrl;

    this.setBDCUrl = function(url) {
        bdcUrl = url;
    };

    this.$get = [
        '$q',
        '$http',
        function($q, $http) {
            let self = {};

            self.getBdcUrl = function() {
                return bdcUrl;
            };

            self.downloadStore = (identifiantMagasin) =>{
                return $http.get(bdcUrl + 'store/' + identifiantMagasin);
            };

            function mapQualif(q) {
                delete q.fournisseur;
                delete q.ancien_fournisseur;
                delete q.type_contrat;
                q.fin_contrat =
                    q.fin_contrat &&
                    new Date(q.fin_contrat)
                        .toISOString()
                        .substring(0, 19)
                        .split('T')
                        .join(' ');
                q.date_signature =
                    q.date_signature &&
                    new Date(q.date_signature)
                        .toISOString()
                        .substring(0, 19)
                        .split('T')
                        .join(' ');
                return q;
            }

            function ids(act) {
                return act.id;
            }

            /**
             * Map an object from store for KYP
             * @param  {Object} store
             * @return {Object} { qualification : {Object}, fieldsToWatch : {Object},
             *   city, departement, postalCode, clientName, phoneNumber
             * }
             */
            function _mapStoreForKYP(store) {
                var data = {};
                data.qualification = mapQualif(angular.copy(store.qualification));
                data.fieldsToWatch = store.fieldsToWatch || [];
                data.city = store.contact.ville;
                data.departement = store.contact.departement;
                data.postalCode = store.contact.code_postal;
                data.clientName = store.customers[0].nom_client;
                data.phoneNumber = store.contact.telephones_portable.length
                    ? store.contact.telephones_portable[0]
                    : store.contact.telephones_fixe[0];
                return data;
            }

            self.updateQualifications = function(store){
                let data = _mapStoreForKYP(store);
                return $http
                    .put(bdcUrl + 'store/' + store.identifiant_magasin + '/qualifications', data)
                    .then(function() {
                        return $http
                            .post(bdcUrl + 'store/synchronise/' + store.identifiant_magasin)
                            .then(res => res.data);
                    })
                    .catch(err => Notification.error('Une erreur est survenue ' + err.data));
            }

            self.upload = function(store) {
                let data = _mapStoreForKYP(store);
                return $http
                    .put(bdcUrl + 'store/' + store.identifiant_magasin + '/qualifications', data)
                    .then(function() {
                        return $http
                            .post(
                                bdcUrl + 'store/uploadActivities/' + store.identifiant_magasin,
                                store.activities.map(ids),
                                '',
                                { transformResponse: undefined }
                            )
                            .then(function(res) {
                                if (store.deleteActivities.length) {
                                    return $http
                                        .post(
                                            bdcUrl + 'store/delActivities/' + store.identifiant_magasin,
                                            store.deleteActivities,
                                            '',
                                            { transformResponse: undefined }
                                        )
                                        .then(function(res) {
                                            return res.data;
                                        });
                                }
                                return res.data;
                            })
                            .then(function() {
                                return $http
                                    .post(bdcUrl + 'store/synchronise/' + store.identifiant_magasin)
                                    .then(res => res.data);
                            });
                    });
            };

            self.getStoresByUserSectors = function() {
                return $http.get(bdcUrl + 'user/user-sector').then(function(res) {
                    const sectors = res.data;
                    if (sectors.length === 0) {
                        return [];
                    }
                    var sectorStr = '';
                    var i = 0;
                    for (const sector of sectors) {
                        if (i !== 0) {
                            sectorStr += ',';
                        }
                        sectorStr += sector.secteur;
                        i++;
                    }

                    return self.downloadStoreDpt(sectorStr);
                });
            };

            self.updateStoreComment = function(data, storeId) {
                console
                return $http
                    .post(bdcUrl + 'store/' + storeId + '/update', { commentaire_general: data.comment, enseigne: data.enseigne })
                    .then(function(res) {
                        return res.data;
                    });
            };

            self.updateStoreContact = function(data, storeId) {
                return $http
                    .put(bdcUrl + 'store/' + storeId + '/contact', data)
                    .then(function(res) {
                        return res.data;
                    });
            };

            self.updateStoreCustomer = function(data, storeId) {
                return $http
                    .put(bdcUrl + 'store/' + storeId + '/customer/' + data.identifiant_client, data)
                    .then(function(res) {
                        return res.data;
                    });
            };

            function storeIdFilter(storeid) {
                return function (s) {
                    return s.identifiant_magasin === storeid;
                };
            }

            function noOldStore(s) {
                return s.etat_magasin != 4;
            }

            /**
             * Download stores from Mongo (RFC cache)
             * @param departements
             * @returns {d.promise}
             */
            self.downloadStoreDpt = function(departements) {
                return $http.get(bdcUrl + 'stores/dept/' + departements).then(function(stores) {
                    return stores.data.filter(noOldStore);
                });
            };

            /**
             * Download stores from Mongo (RFC cache)
             * @param cities
             * @returns {d.promise}
             */
            self.downloadStoreCity = function(cities) {
                return $http.get(bdcUrl + 'stores/city/' + cities).then(function(stores) {
                    return stores.data.filter(noOldStore);
                });
            };

            /**
             * Download last appointment for each store
             * @param storesIds
             * @returns {d.promise}
             */
            self.downloadLastAppointmentForEachStore = function(storesIds) {
                return $http.post(bdcUrl + 'stores/lastAppointments', storesIds).then(function(stores) {
                    return stores.data;
                });
            };

            self.searchAround = function(location) {
                return $http.get(bdcUrl + 'stores/around/' + location).then(function(stores) {
                    return stores.data;
                });
            };

            self.searchAroundAddress = function(address) {
                return $http.get(bdcUrl + 'store/address/' + address).then(function(res) {
                    return res.data;
                });
            };

            self.search = function(query) {
                return $http.get(bdcUrl + 'stores?q=' + query).then(function(stores) {
                    return stores.data;
                });
            };

            self.advanceSearch = function(data) {
                return $http.post(bdcUrl + 'stores', data).then(function(stores) {
                    return stores.data;
                });
            };

            self.generateCsv = function(data) {
                return $http.post(bdcUrl + 'stores/export', data).then(function(res) {
                    return res.data;
                });
            };

            self.updateHours = function(storeId, storeHours) {
                let url = bdcUrl + 'store/updateHours/' + storeId;
                return $http.post(url, storeHours, '', { transformResponse: undefined }).then(function(res) {
                    return res.data;
                });
            };

            self.sendStoreUpdateRequest = function(store, oldStore, user) {
                let parameters = { newStore: store, oldStore: oldStore, user: user };
                return $http.post(bdcUrl + 'store/update-request', parameters).then(function(res) {
                    return res.data;
                });
            };

            self.sendQualificationUpdate = function(store, user) {
                let parameters = { store: store, user: user };
                return $http.post(bdcUrl + 'store/qualifications', parameters).then(function(res) {
                    return res.data;
                });
            };

            self.getAllServices = function(){
                return $http.get(bdcUrl + 'services').then(function(res) {
                    return res.data;
                });
            };

            self.updateMoneyTransfertRanking = function(filename, data) {
                $http.defaults.headers.post['Content-Type'] = 'text/plain';
                return $http
                    .post(bdcUrl + 'store/upload/' + filename, data)
                    .then(function(res) {
                        return res.data;
                    });
            };

            return self;
        }
    ];
}

angular.module('app.prospection.store.storeBackend', []).provider('storeBackend', StoreBackendProvider);
